import {set} from 'vue';

import Routing from 'routing';
import request from '../utils/request';

const SET_ADDRESSES                 = 'SET_ADDRESSES';
const SET_SHIPPING_ADDRESS          = 'SET_SHIPPING_ADDRESS';
const SET_SHIPPING_ADDRESS_ERRORS   = 'SET_SHIPPING_ADDRESS_ERRORS';
const SET_BILLING_ADDRESS           = 'SET_BILLING_ADDRESS';
const SET_BILLING_ADDRESS_ERRORS    = 'SET_BILLING_ADDRESS_ERRORS';
const SET_DEFAULT_BILLING_ADDRESS   = 'SET_DEFAULT_BILLING_ADDRESS';
const SET_GENERAL_ADDRESS_ERRORS    = 'SET_GENERAL_ADDRESS_ERRORS';
const SET_HAS_FORBIDDEN_PRODUCT     = 'SET_HAS_FORBIDDEN_PRODUCT';

const SET_IS_SAME_ADDRESS           = 'SET_IS_SAME_ADDRESS';
const SET_IS_LOADING                = 'SET_IS_LOADING';
const SET_IS_LOADING_ADDRESSES      = 'SET_IS_LOADING_ADDRESSES';
const SET_IS_LOADING_SHIPPING_ADDRESS     = 'SET_IS_LOADING_SHIPPING_ADDRESS';
const SET_IS_LOADING_BILLING_ADDRESS = 'SET_IS_LOADING_BILLING_ADDRESS';
const SET_IS_LOADING_COLISSIMO      = 'SET_IS_LOADING_COLISSIMO';
const SET_INVALID_ADDRESS           = 'SET_INVALID_ADDRESS';
const SET_CARRIER                   = 'SET_CARRIER';
const SET_COLISSIMO_POINTS          = 'SET_COLISSIMO_POINTS';
const SET_COLISSIMO_POINT           = 'SET_COLISSIMO_POINT';

const state = {
    addresses: [],
    shippingAddress : null,
    shippingAddressErrors: {},
    billingAddress: null,
    billingAddressErrors: {},
    defaultBillingAddress: null,
    generalAddressErrors: {},
    isSameAddress: true,
    isLoading: false,
    isLoadingAddresses: false,
    isLoadingShippingAddress: false,
    isLoadingBillingAddress: false,
    isLoadingColissimo: false,
    carrier: null,
    colissimoPoints: null,
    colissimoPoint: null,
    hasForbiddenProduct: false,
    invalidAddress: null,
};

const actions = {
    init() {
        this.dispatch('order/getAddresses');
        this.dispatch('order/getShippingAddress');
        this.dispatch('order/getBillingAddress');
    },

    async getAddresses({commit}) {
        commit(SET_IS_LOADING_ADDRESSES, true);

        try {
            const {data} = await request(Routing.generate('site_checkout_get_addresses'));
            commit(SET_ADDRESSES, JSON.parse(data.addresses) || []);
            commit(SET_IS_LOADING_ADDRESSES, false);
        } catch (err) {
            console.error(err);
        }
    },

    async getShippingAddress({commit}, id) {
        commit(SET_IS_LOADING_SHIPPING_ADDRESS, true);

        let oid = (id === undefined) ? null : id;

        try {
            const {data} = await request(Routing.generate('site_checkout_get_shipping_address', { 'id' : oid }));
            commit(SET_SHIPPING_ADDRESS, JSON.parse(data.shippingAddress) || null);
            commit(SET_IS_LOADING_SHIPPING_ADDRESS, false);
        } catch (err) {
            console.error(err);
        }
    },

    async getBillingAddress({commit}, id) {
        commit(SET_IS_LOADING_BILLING_ADDRESS, true);

        let oid = (id === undefined) ? null : id;

        try {
            const {data} = await request(Routing.generate('site_checkout_get_billing_address', { 'id' : oid }));
            commit(SET_DEFAULT_BILLING_ADDRESS, JSON.parse(data.billingAddress) || null);
            commit(SET_IS_LOADING_BILLING_ADDRESS, false);
        } catch (err) {
            console.error(err);
        }
    },

    async deleteShippingAddress({commit}, id) {
        try {
            const {data} = await request.post(Routing.generate('site_checkout_delete_address'), 'id='+id );
            commit(SET_ADDRESSES, JSON.parse(data.addresses) ||  []);
        } catch (err) {
            console.error(err);
        }

        try {
            const {data} = await request(Routing.generate('site_checkout_get_shipping_address', { 'id' : id }));
            commit(SET_SHIPPING_ADDRESS, JSON.parse(data.shippingAddress) || null);
        } catch (err) {
            console.error(err);
        }
    },

    async deleteBillingAddress({commit}, id) {
        try {
            const {data} = await request.post(Routing.generate('site_checkout_delete_address'), 'id='+id );
            commit(SET_ADDRESSES, JSON.parse(data.addresses) ||  []);
        } catch (err) {
            console.error(err);
        }

        try {
            const {data} = await request(Routing.generate('site_checkout_get_billing_address', { 'id' : id }));
            commit(SET_DEFAULT_BILLING_ADDRESS, JSON.parse(data.billingAddress) || null);
        } catch (err) {
            console.error(err);
        }
    },

    async addShippingAddress({commit}, dataForm) {
        try {
            const {data} = await request.post(Routing.generate('site_checkout_add_or_update_address'), dataForm);

            if (data.errors) {
                commit(SET_SHIPPING_ADDRESS_ERRORS, data.errors || {});
            } else {
                commit(SET_SHIPPING_ADDRESS, JSON.parse(data.address) || null);
                commit(SET_ADDRESSES, JSON.parse(data.addresses) || []);
                commit(SET_SHIPPING_ADDRESS_ERRORS, {});
            }
        } catch (err) {
            console.error(err);
        }
    },

    async addBillingAddress({commit}, dataForm) {
        try {
            const {data} = await request.post(Routing.generate('site_checkout_add_or_update_address'), dataForm);

            if (data.errors) {
                commit(SET_BILLING_ADDRESS_ERRORS, data.errors || {});
            } else {
                commit(SET_BILLING_ADDRESS, JSON.parse(data.address) || null);
                commit(SET_DEFAULT_BILLING_ADDRESS, JSON.parse(data.address) || null);
                commit(SET_ADDRESSES, JSON.parse(data.addresses) || []);
                commit(SET_BILLING_ADDRESS_ERRORS, {});
            }
        } catch (err) {
            console.error(err);
        }
    },

    async getColissimoPoints({commit}, {zipcode, city}) {
        commit(SET_IS_LOADING_COLISSIMO, true);

        try {
            const {data} = await request(Routing.generate('site_checkout_get_colissimo', { 'zipcode' : zipcode, 'city' : city }));
            commit(SET_COLISSIMO_POINTS, JSON.parse(data.colissimoPoints) || {});
            commit(SET_IS_LOADING_COLISSIMO, false);
        } catch (err) {
            console.error(err);
        }
    },

    async addGeneralAddress({commit}, data) {
        let query = data.formData + '&id=' + data.id;
        try {
            const {data} = await request.post(Routing.generate('site_checkout_add_or_update_address'), query);

            if (data.errors) {
                commit(SET_GENERAL_ADDRESS_ERRORS, data.errors || {});
            } else {
                commit(SET_ADDRESSES, JSON.parse(data.addresses) || []);
                commit(SET_GENERAL_ADDRESS_ERRORS, {});
            }
        } catch (err) {
            console.error(err);
        }
    },
};

const getters = {
    addresses(state) {
        return state.addresses;
    },
    shippingAddress(state) {
        return state.shippingAddress;
    },
    shippingAddressErrors(state) {
        return state.shippingAddressErrors;
    },
    billingAddress(state) {
        return state.billingAddress;
    },
    billingAddressErrors(state) {
        return state.billingAddressErrors;
    },
    generalAddressErrors(state) {
        return state.generalAddressErrors;
    },
    isSameAddress(state) {
        return state.isSameAddress;
    },
    isLoading(state) {
        return state.isLoading;
    },
    isLoadingAddresses(state) {
        return state.isLoadingAddresses;
    },
    isLoadingShippingAddress(state) {
        return state.isLoadingShippingAddress;
    },
    isLoadingBillingAddress(state) {
        return state.isLoadingBillingAddress;
    },
    isLoadingColissimo(state) {
        return state.isLoadingColissimo;
    },
    carrier(state) {
        return state.carrier;
    },
    colissimoPoints(state) {
        return state.colissimoPoints;
    },
    colissimoPoint(state) {
        return state.colissimoPoint;
    },
    colissimoPointData(state) {
      for(let i = 0; i < state.colissimoPoints.length; i++) {
        if (state.colissimoPoint === state.colissimoPoints[i]['identifiant']) {
          return state.colissimoPoints[i];
        }
      }

      return null;
    },
    hasForbiddenProduct(state) {
        return state.hasForbiddenProduct;
    },
    invalidAddress(state) {
        return state.invalidAddress;
    },
};

const mutations = {
    [SET_IS_LOADING](state, data) {
        set(state, 'isLoading', data);
    },
    [SET_IS_LOADING_ADDRESSES](state, data) {
        set(state, 'isLoadingAddresses', data);
    },
    [SET_IS_LOADING_SHIPPING_ADDRESS](state, data) {
        set(state, 'isLoadingShippingAddress', data);
    },
    [SET_IS_LOADING_COLISSIMO](state, data) {
        set(state, 'isLoadingColissimo', data);
    },
    [SET_IS_LOADING_BILLING_ADDRESS](state, data) {
        set(state, 'isLoadingBillingAddress', data);
    },
    [SET_ADDRESSES](state, data) {
        set(state, 'addresses', data);
    },

    [SET_SHIPPING_ADDRESS](state, data) {
        set(state, 'shippingAddress', data);
        set(state, 'shippingAddressErrors', {});

        if (state.isSameAddress === true) {
            set(state, 'billingAddress', data);
        }
    },
    [SET_SHIPPING_ADDRESS_ERRORS](state, data) {
        set(state, 'shippingAddressErrors', data);
    },
    [SET_BILLING_ADDRESS](state, data) {
        if (state.isSameAddress === false) {
            set(state, 'billingAddress', data);
        }
    },
    [SET_BILLING_ADDRESS_ERRORS](state, data) {
        set(state, 'billingAddressErrors', data);
    },
    [SET_DEFAULT_BILLING_ADDRESS](state, data) {
        set(state, 'defaultBillingAddress', data);

        if (state.isSameAddress === false) {
            set(state, 'billingAddress', data);
        }
    },
    [SET_GENERAL_ADDRESS_ERRORS](state, data) {
        set(state, 'generalAddressErrors', data);
    },
    [SET_IS_SAME_ADDRESS](state, data) {
        set(state, 'isSameAddress', data);

        if (state.isSameAddress === true) {
            set(state, 'billingAddress', state.shippingAddress);
        } else if (state.defaultBillingAddress) {
            set(state, 'billingAddress', state.defaultBillingAddress);
        } else {
            set(state, 'billingAddress', null);
        }
    },
    [SET_CARRIER](state, data) {
        set(state, 'carrier', data);
    },
    [SET_COLISSIMO_POINTS](state, data) {
        if (null !== state.carrier && true === state.carrier.isRelay) {
            set(state, 'colissimoPoints', data)
            set(state, 'colissimoPoint', data[0].identifiant);
        }
    },
    [SET_COLISSIMO_POINT](state, data) {
        set(state, 'colissimoPoint', data)
    },
    [SET_HAS_FORBIDDEN_PRODUCT](state, data) {
        set(state, 'hasForbiddenProduct', data);
    },
    [SET_INVALID_ADDRESS](state, data) {
        set(state, 'invalidAddress', data);
    }
};

const Store = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

export default Store;



// WEBPACK FOOTER //
// ./src/SiteBundle/Resources/assets/store/modules/order.js